<component :is="tagName" class="ippro-icon-text">
  <vl-icon :icon="icon" :class="iconClasses" v-if="icon && !modIconAfter" />
  <slot></slot>
  <vl-icon :icon="icon" :class="iconClasses" v-if="icon && modIconAfter" />
</component>
